// Ported from the original design mockup into TS module form.
// The React <ThemeToggle/> handles UI; this module owns persistence + init.
const KEY = "subswall-theme";

export type Theme = "light" | "dark";

export function getTheme(): Theme {
  return document.documentElement.getAttribute("data-theme") === "light" ? "light" : "dark";
}

export function setTheme(theme: Theme): void {
  if (theme === "light") {
    document.documentElement.setAttribute("data-theme", "light");
  } else {
    document.documentElement.removeAttribute("data-theme");
  }
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    // ignore
  }
}

export function toggleTheme(): Theme {
  const next: Theme = getTheme() === "light" ? "dark" : "light";
  setTheme(next);
  return next;
}

export function initTheme(): void {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved === "light") {
      document.documentElement.setAttribute("data-theme", "light");
    }
  } catch {
    // ignore
  }
}
